import React from 'react';

function DemocraticRepublicOfCongo(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124168)">
        <mask
          id="mask0_800_124168"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124168)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#3195F9"
          />
          <mask
            id="mask1_800_124168"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124168)">
            <path
              d="M-1.87923 25.4959L-1.20603 26.3924L-0.241841 25.8203L40.5517 1.61682L41.7503 0.905669L40.9134 -0.208791L38.4152 -3.53574L37.742 -4.43225L36.7778 -3.86018L-4.01576 20.3433L-5.21436 21.0544L-4.37749 22.1689L-1.87923 25.4959Z"
              fill="#E31D1C"
              stroke="#FECA00"
              strokeWidth="2.5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.54699 8.60629L1.62565 11.024L2.87866 6.88304L0 4.23781L3.89787 4.09478L5.54699 0L7.1961 4.09478H11.0873L8.21531 6.88304L9.65367 10.7796L5.54699 8.60629Z"
              fill="#FECA00"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124168">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DemocraticRepublicOfCongo;
